/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AccountingCurrency from './accounting-currency';
import AccountingCurrencyDetail from './accounting-currency-detail';
import AccountingCurrencyUpdate from './accounting-currency-update';
import AccountingCurrencyDeleteDialog from './accounting-currency-delete-dialog';

const AccountingCurrencyRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AccountingCurrency />} />
    <Route path="new" element={<AccountingCurrencyUpdate />} />
    <Route path=":id">
      <Route index element={<AccountingCurrencyDetail />} />
      <Route path="edit" element={<AccountingCurrencyUpdate />} />
      <Route path="delete" element={<AccountingCurrencyDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AccountingCurrencyRoutes;
